var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 6.0415C10.3451 6.0415 10.625 6.32133 10.625 6.6665V9.37484H13.3333C13.6785 9.37484 13.9583 9.65466 13.9583 9.99984C13.9583 10.345 13.6785 10.6248 13.3333 10.6248H10.625V13.3332C10.625 13.6783 10.3451 13.9582 9.99996 13.9582C9.65478 13.9582 9.37496 13.6783 9.37496 13.3332V10.6248H6.66663C6.32145 10.6248 6.04163 10.345 6.04163 9.99984C6.04163 9.65466 6.32145 9.37484 6.66663 9.37484H9.37496V6.6665C9.37496 6.32133 9.65478 6.0415 9.99996 6.0415Z",
    fill: "#2E2E38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 2.2915C5.74276 2.2915 2.29163 5.74264 2.29163 9.99984C2.29163 14.257 5.74276 17.7082 9.99996 17.7082C14.2572 17.7082 17.7083 14.257 17.7083 9.99984C17.7083 5.74264 14.2572 2.2915 9.99996 2.2915ZM1.04163 9.99984C1.04163 5.05229 5.05241 1.0415 9.99996 1.0415C14.9475 1.0415 18.9583 5.05229 18.9583 9.99984C18.9583 14.9474 14.9475 18.9582 9.99996 18.9582C5.05241 18.9582 1.04163 14.9474 1.04163 9.99984Z",
    fill: "#2E2E38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.5b12f8b38963d478f8b17560d4a62472.svg";
export { ForwardRef as ReactComponent };